import { useMemo } from "react";
import { useDispatchApp } from "../lib/redux";
import { getRoleCapability } from "../actions/getters";

export const useGalleryPermissions = () => {
  const dispatch = useDispatchApp();

  return useMemo(() => {
    const canEditGallery = dispatch(getRoleCapability("canEditGallery"));
    const canCreateCampaign = dispatch(getRoleCapability("canCreateCampaign"));
    const canPost = dispatch(getRoleCapability("canPost"));

    return {
      canEditGallery,
      canCreateCampaign,
      canPost,
      showActionButtons: canEditGallery,
      showResizeFormatButton: canEditGallery,
      showDeleteButton: canEditGallery,
      showPreviewExpandOnly: !canEditGallery,
      showContentApproval: canEditGallery,
      showEditInPreview: canEditGallery,
      showShareInPreview: canPost,
      showPostButton: canPost,
      showDeleteInPreview: canEditGallery,
      showFooterDeleteSelected: canEditGallery,
      showFooterAddToCampaign: canEditGallery,
      showFooterCreateCampaign: canCreateCampaign,
      showPreviewCustomActions: canEditGallery,
    };
  }, [dispatch]);
};
